import { registerRoot } from "remotion";
import { RemotionRoot } from "./Root";
import "./styles/tailwind.css";

registerRoot(RemotionRoot);
